import { render, staticRenderFns } from "./SurveyEnvirodataDetails.vue?vue&type=template&id=09be3d49"
import script from "./SurveyEnvirodataDetails.vue?vue&type=script&lang=js"
export * from "./SurveyEnvirodataDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports